import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Modal } from 'react-bootstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './aprovar-noticia.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Tooltip,
  Stack,
  Checkbox,
  IconButton,
  Spinner,
  RadioGroup,
  Radio,
  Wrap,
  TagLabel,
  TagCloseButton,
  Tag,
  WrapItem,
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/noticia';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { ImageDropzoneDisabled } from '../../../../components/common/imageDropzoneDisabled/imageDropzoneDisabled';
import * as apiPendencia from '../../../../api/pendencia';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const AprovarNoticia: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    endereco: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    seqCategoria: { value: any; error: boolean };
    paginaId: { value: any[]; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
    usuarioId: { value: any; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    endereco: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    texto: { value: '', error: false },
    seqCategoria: { value: '', error: false },
    paginaId: { value: [], error: false },
    exigeAprovacao: { value: 0, error: false },
    usuarioId: { value: null, error: false },

  });

  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [temporaryTexto, setTemporaryTexto] = useState<string>('');
  const [isModalTextOpen, setIsModalTextOpen] = useState<boolean>(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [executor, setExecutor] = useState<any[]>([]);
  const [isReprovandoButton, setReprovandoButton] = useState<boolean>(false);
  const [isAprovandoButton, setAprovandoButton] = useState<boolean>(false);
  const [tagUsuario, setTagUsuario] = useState<string>('');

  const fetchNoticiaData = async () => {
    setIsLoading(true);
    try {
      const NoticiaData = await api.obterNoticia(Number(id));
      const { nomePublicacao, datPublicacao, datDespublicar, dscCreditoImagem, dscCreditoNoticia, seqCategoria, conteudoPaginaDTO, binPublicacao, urlBin, dscResumo, dscPublicacao, pendencia, dscCitacaoUsuario } = NoticiaData;

      setExecutor(NoticiaData.pendencia.seqExecutor)

      let exigeAprovacaoValue = 0;

      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
        setSelectedUser(pendencia.seqExecutor);
      }
      const usuarioIdValue = pendencia?.seqExecutor;

      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));

      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        imagem: { value: binPublicacao || '', error: false },
        endereco: { value: urlBin || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: '', error: false },
        seqCategoria: { value: seqCategoria || '', error: false },
        paginaId: { value: conteudoPaginaDTO.map((item: any) => item.seqPagina.toString()), error: false },
        dscResumo: { value: dscResumo || '', error: false },
        creditoAutorNoticia: { value: dscCreditoNoticia || '', error: false },
        texto: { value: dscPublicacao || '', error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        usuarioId: { value: usuarioIdValue || '', error: false },
      });

    } catch (error) {
      console.error("Erro ao buscar dados do banner:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);

      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchNoticiaData();
    fetchAprovadoresAtivos();
    fetchPaginas();
  }, []);

  const handleReprovarPublicacao = async () => {

    const { usuarioId } = formValues;

    const motivoReprovacao = await Swal.fire({
      input: 'textarea',
      width: '50%',
      title: 'Qual é o motivo da reprovação?',
      inputPlaceholder: 'Digite o motivo da reprovação aqui',
      inputAttributes: {
        'aria-label': 'Digite o motivo da reprovação aqui'
      },
      reverseButtons: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Enviar Motivo',
      confirmButtonColor: '#1665D8',
      cancelButtonColor: '#EDF2F7',
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {
          confirmButton.disabled = true;
          const input = Swal.getInput();
          if (input) {
            input.addEventListener('input', () => {
              confirmButton.disabled = input.value.trim().length < 1;
            });
          }
        }
      },
    });

    if (motivoReprovacao.isConfirmed) {
      setReprovandoButton(true);
      const params = {
        pendencia: {
          codPendencia: 1,
          seqSolicitante: seqUsuario,
          seqExecutor: usuarioId.value,
          dscObs: motivoReprovacao.value,
        }
      };

      try {
        await apiPendencia.reprovarConteudo(Number(id), params);
        setReprovandoButton(false);
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'A publicação foi reprovada com sucesso.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      } catch (error) {
        setReprovandoButton(false);
        console.error('Erro ao reprovar publicação:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao reprovar a publicação. Tente novamente.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      }
    }
  };

  const handleOpenModal = () => {
    setTemporaryTexto(formValues.texto.value);
    setIsModalTextOpen(true);
  };

  useEffect(() => {
    const isAutorValid = formValues.creditoAutorNoticia.value.trim() !== '';
    setIsSaveButtonDisabled(!isAutorValid || !temporaryTexto);
  }, [formValues.creditoAutorNoticia.value, temporaryTexto]);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAprovandoButton(true);

    const params = Number(id);

    try {
      await apiPendencia.aprovarConteudo(params);
      setAprovandoButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação aprovada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    } catch (error) {
      setAprovandoButton(false);
      console.error('Erro ao aprovar publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao aprovar publicação. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/inicio/visualizacao-necessidade-atuacao');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      < SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Aprovar Notícia
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.seqCategoria.error}>
                  <FormLabel mb="8px">Categoria da Notícia</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.seqCategoria.value}
                    disabled={true}
                    className='opacidade'
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título da Notícia</FormLabel>
                  <CustomInput
                    className='opacidade'
                    isDisabled={true}
                    value={formValues.titulo.value}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Endereço de Internet para a notícia</FormLabel>
                  <CustomInput
                    className='opacidade'
                    isDisabled={true}
                    value={formValues.endereco.value}
                  />
                </FormControl>
              </div>

              <div className="col-md-3 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Data para Publicação</FormLabel>
                  <CustomInput
                    className='opacidade'
                    isDisabled={true}
                    id="news-approve-publication-date"
                    type="date"
                    value={formValues.data.value}
                    min={today}
                  />
                </FormControl>
              </div>
              <div className="col-md-3 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                  <CustomInput
                    className='opacidade'
                    isDisabled={true}
                    id="news-approve-unpublish-date"
                    type="date"
                    value={formValues.dataFim.value}
                    min={today}
                  />
                </FormControl>
              </div>

            </div>
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Imagem miniatura</FormLabel>
                  <ImageDropzoneDisabled
                    base64={formValues.imagem.value || ''}
                  />
                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                  />
                </FormControl>

                {formValues.imagem.value && (
                  <FormControl isRequired className="mt-3">
                    <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                    <CustomInput
                      className='opacidade'
                      isDisabled={true}
                      value={formValues.creditoAutorImagem.value}
                    />
                  </FormControl>
                )}
                {formValues.imagem.value && (
                  <FormControl className="mt-3">
                    <FormLabel mb="8px">Descrição de imagem</FormLabel>
                    <CustomInput
                      className='opacidade'
                      isDisabled={true}
                      value={formValues.descricaoImagem.value}
                    />
                  </FormControl>
                )}
                <input
                  id="image-upload"
                  type="file"
                  style={{ display: 'none' }}
                  accept="image/jpeg, image/png"
                />
                <FormControl mt={'24px'}>
                  <FormLabel mb="8px">Tags</FormLabel>
                </FormControl>
                <div className="rolagem-hashtag mb-2">
                  <Wrap spacing="2px">
                    {tagUsuario && tagUsuario.trim().length > 0 ? (
                      tagUsuario.split(" ").map((tag, index) => (
                        <WrapItem key={index}>
                          <Tooltip label={tag} placement="top" hasArrow>
                            <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                              <TagLabel>{tag}</TagLabel>
                            </Tag>
                          </Tooltip>
                        </WrapItem>
                      ))
                    ) : (
                      <p>Não há tags</p>
                    )}
                  </Wrap>
                </div>

                <FormControl>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px" mt={'24px'}>
                      Escolha em quais páginas a notícia deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>
                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina: any) => (
                          <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                            <Checkbox
                              disabled={true}
                              className="checkPaginasNoticia"
                              isChecked={formValues.paginaId.value.includes(pagina.seqPagina.toString())}
                              sx={{
                                '.chakra-checkbox__label': {
                                  opacity: 1,
                                  userSelect: 'none',
                                },
                              }}
                            >
                              {pagina.nomPagina}
                            </Checkbox>
                          </Flex>
                        ))
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Resumo da Notícia</FormLabel>
                  <CustomTextArea
                    className='opacidade'
                    isDisabled={true}
                    value={formValues.dscResumo.value}
                    height={'90px'}
                  />
                </FormControl>

                <div className="row mt-4">
                  <div className="col-md-6 mb-4">
                    <Button
                      onClick={handleOpenModal}
                      variant="outline"
                      colorScheme="blue"
                      size="lg"
                      fontSize="md"
                      borderRadius="md"
                      _hover={{ bg: "blue.500", color: "white" }}
                      mt={3}
                    >
                      Texto da Notícia
                    </Button>
                  </div>

                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        isDisabled={true}
                        className='opacidade'
                        mt={3.5}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                {formValues.exigeAprovacao.value === 1 && (
                  <div className="col-md-12 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                      <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                        <Stack spacing={5}>
                          {aprovadores.length > 0 ? (
                            aprovadores.map((aprovador: any) => (
                              <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                <Radio
                                  isDisabled={true}
                                  className="opacidade radioAprovadoresNoticia"
                                  value={aprovador.seqUsuario.toString()}
                                  isChecked={selectedUser === aprovador.seqUsuario}
                                >
                                  {aprovador.dscNome}
                                </Radio>
                              </Flex>
                            ))
                          ) : (
                            <p>Não há lista de aprovadores disponíveis.</p>
                          )}
                        </Stack>
                      </div>
                    </FormControl>
                  </div>
                )}

              </div>
            </div>

            <Flex justifyContent="end">
              <Button
                m="6px"
                onClick={handleReprovarPublicacao}
                isDisabled={executor != seqUsuario}
                isLoading={isReprovandoButton}
                loadingText="Reprovando Publicação..."
              >
                Reprovar Publicação
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={executor != seqUsuario}
                isLoading={isAprovandoButton}
                loadingText="Aprovando Publicação..."
              >
                Aprovar Publicação
              </Button>
            </Flex>
            <Flex hidden={executor == seqUsuario} justifyContent="end">
              <p className='mansagem-erro-executor'>
                Você não é o aprovador desta publicação.
              </p>
            </Flex>
          </form>
        </Box>
      )}

      <Modal show={isErrorModalOpen} onHide={() => setIsErrorModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsErrorModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={isModalTextOpen} onHide={() => setIsModalTextOpen(false)} size="xl" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>Digite o texto da notícia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormControl>
            <CKEditor
              disabled={true}
              editor={ClassicEditor}
              data={temporaryTexto}
              config={{
                language: 'pt-br',
                toolbar: [
                  'undo', 'redo', '|',
                  'heading', 'bold', 'italic', 'underline', 'strikethrough', '|',
                  'link', '|',
                  'blockQuote', 'insertTable', '|',
                  'horizontalLine',
                ],
                heading: {
                  options: [
                    {
                      model: 'paragraph',
                      title: 'Texto normal',
                      class: 'ck-heading_paragraph'
                    },
                    {
                      model: 'heading1',
                      view: 'h1',
                      title: 'Cabeçalho 1',
                      class: 'ck-heading_heading1'
                    },
                    {
                      model: 'heading2',
                      view: 'h2',
                      title: 'Cabeçalho 2',
                      class: 'ck-heading_heading2'
                    },
                    {
                      model: 'heading3',
                      view: 'h3',
                      title: 'Cabeçalho 3',
                      class: 'ck-heading_heading3'
                    },
                  ]
                },
              }}
            />
          </FormControl>
          {temporaryTexto && (
            <FormControl isRequired className="mt-3 mb-4">
              <FormLabel>Crédito/Autor da notícia</FormLabel>
              <CustomInput
                className='opacidade'
                isDisabled={true}
                value={formValues.creditoAutorNoticia.value}
                maxLength={100}
              />
            </FormControl>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            m="6px"
            color="#FFF"
            bgColor="#1665D8"
            _hover={{ opacity: 0.8 }}
            onClick={() => setIsModalTextOpen(false)}
          >
            Voltar
          </Button>
          {/* <Button variant="primary" onClick={handleSaveText} disabled={isSaveButtonDisabled}>
            Salvar
          </Button> */}
        </Modal.Footer>
      </Modal>
    </Flex>
  );
};

export default AprovarNoticia;
